import { render, staticRenderFns } from "./ContentGoals.vue?vue&type=template&id=c960179a&scoped=true&lang=pug&"
import script from "./ContentGoals.vue?vue&type=script&lang=js&"
export * from "./ContentGoals.vue?vue&type=script&lang=js&"
import style0 from "./ContentGoals.vue?vue&type=style&index=0&id=c960179a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c960179a",
  null
  
)

export default component.exports